export default __webpack_public_path__ + "static/media/mikecodeur.69149273.webp";